<template>
    <div class="full-page comm">
        <div class="comm-section-intro">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="text-wrapper">
                            <h3>行动计划智能管理</h3>
                            <h4>
                                系统提供年/季/月/周计划表，可按周期填写，如实记录完成情况。计划可细化到每一天，并且可以根据截止时间，在即将到期却未完成时自动提醒。
                            </h4>
                                 <router-link :to="{ name: 'appsplan'}" title="前往制定计划" class="goto_plan">
                                         制定计划 >>
                                        </router-link>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="img-wrapper">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="comm-grid-layout">
            <div class="home-advantage-container">
                <ul class="row">
                    <li class="col-md-3">
                        <div class="media-vertical-card J-cardItem" style="height: 360px;">
                            <div class="media-img"><img src="https://main.qcloudimg.com/raw/2ce04d822d92d6b311b5206ef6380628.svg"></div>
                            <div class="media-body"><p class="media-heading">日程安排</p>
                                <p class="media-info">各项任务按轻重缓急逐一击破</p>
                                <dl class="media-textlist">
                                    <dt>主要功能</dt>
                                    <dd>从此告别杂乱无序</dd>
                                    <dd>开启井井有条的工作、学习模式</dd>
                                    <dd>帮助你更好的提高效率</dd>
                                </dl>
                            </div>
                        </div>
                    </li>
                    <li class="col-md-3">
                        <div class="media-vertical-card J-cardItem" style="height: 360px;">
                            <div class="media-img"><img src="https://main.qcloudimg.com/raw/96879c237222ff222bb264d72254d0e3.svg"></div>
                            <div class="media-body"><p class="media-heading">计划管理</p>
                                <p class="media-info">年季月周，工作、学习轻松搞定</p>
                                <dl class="media-textlist">
                                    <dt>主要功能</dt>
                                    <dd>每一项计划，你都能编写详情</dd>
                                    <dd>可以设置提醒时间、发表评论</dd>
                                    <dd>计划进展一目了然</dd>
                                    <dd>每个人都知道该做什么、为什么做</dd>
                                </dl>
                            </div>
                        </div>
                    </li>
                    <li class="col-md-3">
                        <div class="media-vertical-card J-cardItem" style="height: 360px;">
                            <div class="media-img"><img src="https://main.qcloudimg.com/raw/9aa0b6c1ecaddff004b4968bbdd3a062.svg"></div>
                            <div class="media-body"><p class="media-heading">行动笔记</p>
                                <p class="media-info">学习、工作如实记录，随时编写</p>
                                <dl class="media-textlist">
                                    <dt>主要功能</dt>
                                    <dd>自动记录你的全方位成长经历</dd>
                                    <dd>随时撰写学习心得、工作笔记</dd>
                                    <dd>相关人员可在线查阅和反馈</dd>
                                    <dd>笔记内容同步个人文集</dd>
                                </dl>
                            </div>
                        </div>
                    </li>
                    <li class="col-md-3">
                        <div class="media-vertical-card J-cardItem" style="height: 360px;">
                            <div class="media-img"><img src="https://main.qcloudimg.com/raw/7c7111fddffdd72d828ec68cbe778662.svg"></div>
                            <div class="media-body"><p class="media-heading">总结分析</p>
                                <p class="media-info">周报、月报、小结、总结一键生成</p>
                                <dl class="media-textlist">
                                    <dt>主要功能</dt>
                                    <dd>回顾变得简单，操作变得方便</dd>
                                    <dd>总结更加全面</dd>
                                    <dd>分析更加精准</dd>
                                </dl>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <section class="comm-section-webpage">
            <div class="container">
                <div class="comm-presentation">
                    <div class="comm-presentation-img left"><img
                            src="/static/img/plan_kanban.png"></div>
                    <div class="comm-presentation-text"><h4>按时间“四象限”法分类当前事项</h4>
                        <div>
                            ▪ 紧急且重要(如客户投诉、计划好的会议、即将到期的任务等)<br/>
                            ▪ 重要不紧急(如建立人际关系、人员培训、制订防范措施等)<br/>
                            ▪ 紧急不重要(如电话铃声、不速之客、同事要求协助等)<br/>
                            ▪ 不紧急不重要(如上网、闲谈、邮件、写博客、朋友圈等)
                        </div>
                    </div>
                </div>
                <div class="comm-presentation">
                    <div class="comm-presentation-img right"><img
                            src="/static/img/page_plan_list.jpg"></div>
                    <div class="comm-presentation-text"><h4>“年/季/月/周”计划分级管理</h4>
                        <div>
                            ▪ “年/季”视图和“月/周”视图切换<br/>
                            ▪ 计划可分解为明细，可视为工作计划的具体安排<br/>
                            ▪ 最小计划到天，可记录完成进度<br/>
                            ▪ 设置计划起止时间，可实现自动提醒
                        </div>
                    </div>
                </div>
                <div class="comm-presentation">
                    <div class="comm-presentation-img left"><img
                            src="/static/img/page_plan_note.jpg"></div>
                    <div class="comm-presentation-text"><h4>随时编写，云端同步</h4>
                        <div>
                            ▪ 完成学习同步完成学习计划<br/>
                            ▪ 撰写笔记同步关联工作计划<br/>
                            ▪ 心得、笔记自动归档个人文集<br/>
                            ▪ 多终端同步访问云端数据
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>
<script type="text/javascript">
    // import LiveCourseCard from '@/components/common_components/cards/live_course_card.vue'

    import {mapState} from 'vuex'

    export default {
        components: {},
        computed: {
            ...mapState({
                not_ended_live_courses: state => state.live.not_ended_live_courses,
                ended_live_courses: state => state.live.ended_live_courses
            })
        }
    }
</script>
<style type="text/css" scoped>


    .row {
        display: -webkit-box;
        display: flex;
        flex-wrap: wrap;
        padding: 15px;
    }

    .text-wrapper {
        margin-top: 50px;
    }

    .text-wrapper > h3 {
        margin: 0;
        font-size: 35px;
        font-weight: 400;
        color: #fff;
    }

    .text-wrapper > h4 {
        margin: 20px 0 20px;
        font-size: 20px;
        font-weight: 400;
        color: #eee;
    }

    .text-wrapper .btn-groups > a:first-of-type {
        margin-right: 30px;
    }

    .text-wrapper .btn-groups > a {
        width: 194px;
        height: 44px;
        line-height: 29px;
    }

    .comm {
        /*background: url(https://static.shiyanlou.com/frontend/dist/img/8f5ba7f.png);*/
        background-color: #fff;
    }

    .comm section {
        padding: 1px 0;
    }

    .img-wrapper {
        display: inline-block;
        width: 420px;
        height: auto;
    }

    img {
        vertical-align: middle;
        max-width: 100%;
        height: auto;
    }

    .comm-presentation {
        width: 90%;
        margin: 100px auto;
        overflow: hidden;
    }

    .comm-presentation .comm-presentation-img {
        margin-right: 20px;
        filter: blur(0.5px);
        -webkit-filter: blur(0.5px);
    }

    .comm-presentation .left {
        float: left;
    }

    .comm-presentation .right {
        float: right;
    }

    .comm-presentation .comm-presentation-img img {
        max-width: 560px;
    }

    .comm-presentation .comm-presentation-text {
        margin-top: 10px;
        width: auto;
        font-size: 18px;
        color: #666;
    }


    .common_page_content {
        width: 1170px;
        margin: auto;
        padding: 30px;
    }

    .common_description_title {
        margin: 45px 0 26px;
        color: #666;
    }

    .no_courses_warning {
        color: #a4a4a4;
        font-size: 18px;
    }

    .common_ended_courses {
        display: flex;
        flex-wrap: wrap;
    }

    .common_courses_card {
        width: 33.333%
    }

    .comm-section-intro {
        background-color: #f5f7fa;
        background-image: url(/static/img/bg-home-banner-pc-blue.jpg);
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        height: 360px;
    }

    .comm-grid-layout {
        max-width: 1200px;
        margin: 0 auto;
    }

    .home-advantage-container {
        background-color: transparent;
        margin-top: -60px;
        overflow: hidden;
        padding: 5px 5px;
        position: relative;
        z-index: 9;
    }

    .media-vertical-card {
        background-color: #fff;
        border: 1px solid #e5e8ed;
        border-radius: 2px;
        box-shadow: 0 2px 8px 0 rgba(3, 27, 78, .12);
        padding: 20px;
    }

    .media-vertical-card .media-img {
        margin-bottom: 1px;
    }

    .media-vertical-card .media-img img {
        width: 108px;
        height: 108px;
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    .media-vertical-card .media-heading {
        text-align: center;
        font-size: 18px;
        line-height: 25px;
        color: #000;
        margin-bottom: 10px;
    }

    .media-vertical-card .media-info {
        font-size: 14px;
        color: #666;
        /*line-height: 24px;*/
    }

    .media-vertical-card .media-textlist {
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #e5e5e5;
    }

    .media-vertical-card .media-textlist dt {
        font-size: 12px;
        line-height: 18px;
        font-weight: 700;
        color: #333;
        margin-bottom: 10px;
    }

    .media-vertical-card .media-textlist dd {
        color: #666;
        font-size: 12px;
        /*line-height: 18px;*/
        padding-left: 7px;
        position: relative;
    }
    .goto_plan{
        float: right;font-size: 20px;color: blanchedalmond;font-weight: bold;
    }
    .goto_plan:hover{
        color:#0a6999;
       text-decoration-line: underline;
    }
</style>